<template>
  <div class="animated fadeIn list-of-arpaym">
    <b-card>
      <div slot="header">{{this.$route.meta.title}} 
        <div class="card-header-actions">
          <b-dropdown text="Action" variant="primary" class="mr-1">
            <b-dropdown-item @click="add">
              <i class="fa fa-file"></i>Add
            </b-dropdown-item>
            <b-dropdown-item @click="edit"  :disabled="(model.isvoid==1 || model.poststatus==1)">
              <i class="fa fa-pencil"></i>Edit
            </b-dropdown-item>
            <b-dropdown-item @click="deleteConfirm" :disabled="(model.isvoid==1 || model.poststatus==1)">
              <i class="fa fa-trash"></i>Delete
            </b-dropdown-item>
            <b-dropdown-item @click="voidConfirm" :disabled="(model.isvoid==1 || model.poststatus!=1)">
              <i class="fa fa-exchange"></i>Reverse
            </b-dropdown-item>
            <b-dropdown-item @click="postingConfirm()">
              <i class="fa fa-upload"></i>Posting Bulk
            </b-dropdown-item>
            <b-dropdown-item @click="unpostingConfirm()">
              <i class="fa fa-download"></i>Un-Posting Bulk
            </b-dropdown-item>
          </b-dropdown>
          <!-- <b-button variant="primary mr-1" @click="viewwithline">View with Detail</b-button> -->
          <!-- <b-button variant="primary mr-1" @click="printjv()"><i class="fa fa-print"></i> Print Form</b-button> -->
          <b-button variant="primary mr-1" @click="exportxls()"><i class="fa fa-file-excel-o"></i>Export</b-button>
          <b-button variant="primary mr-1" @click="togleFilter()"><i class="fa fa-filter"></i> Filter</b-button>
        </div>
      </div>
      <b-row v-if="showFilter">
        <b-col lg="6">
            <b-row>
              <b-col lg="12">
                  <b-input-group >
                    <b-input-group-prepend><label class="label-eko">Periode Date</label></b-input-group-prepend>
                    <b-form-select v-model="tblData.optiondate" :plain="true" :options="dateOpt"></b-form-select>
                    <b-form-input v-model="tblData.tgl1" type="date" ></b-form-input>
                    <b-input-group-prepend><span class="input-group-text">until</span></b-input-group-prepend>
                    <b-form-input v-model="tblData.tgl2" type="date" ></b-form-input>
                  </b-input-group>
                </b-col>
            </b-row>            
            <b-row>
              <b-col lg="6">
                  <b-input-group >
                    <b-input-group-prepend><label class="label-eko">Payment No</label></b-input-group-prepend>
                    <b-form-input v-model="tblData.nomor" placeholder="Payment Number"></b-form-input>
                  </b-input-group>
                </b-col>
              <b-col  lg="6">
                  <b-input-group >
                    <b-input-group-prepend><label class="pt-2 label-eko">Receipt From &nbsp;</label></b-input-group-prepend>
                    <b-form-input v-model="tblData.customer" placeholder="Debitur Name"></b-form-input>
                    </b-input-group>
              </b-col>
            </b-row>                      
        </b-col>
        <b-col lg="6">
              <b-input-group >
                  <b-input-group-prepend><label class="label-eko pt-2">Posting Trx</label></b-input-group-prepend>
                  <b-form-select v-model="tblData.poststatus" :plain="true" :options="postingOpt" ></b-form-select>
                  <b-input-group-prepend><label class="label-eko">Bank Finance</label></b-input-group-prepend>
                  <b-form-input v-model="tblData.namabank" disabled ></b-form-input>
                  <b-input-group-append>
                      <b-btn text="Button" @click="lkuBankaccountShow=true">
                          <i class="fa fa-search"></i>
                      </b-btn>
                  </b-input-group-append>
                  <!-- <b-input-group-prepend><span class="pt-2">&nbsp;Effective</span></b-input-group-prepend>
                  <b-form-input v-model="tblData.tgldue1" type="date" ></b-form-input>
                  <b-input-group-prepend><span class="input-group-text">until</span></b-input-group-prepend>
                  <b-form-input v-model="tblData.tgldue2" type="date" ></b-form-input> -->
              </b-input-group>
              <b-input-group >
                <b-input-group-prepend><label class="label-eko">Collector</label></b-input-group-prepend>
                <b-form-select v-model="tblData.collector_id" :plain="true" :options="collectors" ></b-form-select>
                <b-form-input
                  v-model="tblData.no_kontrak"
                  placeholder="No Kontrak"
                ></b-form-input>
                <b-input-group-append>
                      <b-button variant="success" size="sm" @click="refresh()" class="ml-3"> <i class="fa fa-refresh"></i> Apply Filter</b-button>                
                </b-input-group-append>
                <b-input-group-append>
                      <b-button variant="secondary" size="sm" class="ml-2" @click="clearFilter()" >Clear Filter</b-button>
                </b-input-group-append>
              </b-input-group>
        </b-col>
      </b-row>
      <b-table
        class="mb-0"
        ref="table"
        outlined
        responsive striped hover small
        style="font-size:smaller;" 
        :items="data"
        :fields="tblFields"
        :current-page="tblData.page"
        :per-page="tblData.limit"
        :sort-by.sync="tblData.sortBy"
        :sort-desc.sync="tblData.sortDesc"
        :key="tblData.limit" @row-clicked="rowClicked"
        show-empty 
      >
      <!-- <template v-slot:thead-top="data">
        <b-tr>
          <b-th colspan="12">
              <span class="sr-only">&nbsp;</span>
            </b-th>
          <b-th variant="warning" colspan="4" class="text-center">REVERSE</b-th>
        </b-tr>
      </template> -->
      <template v-slot:cell(action)="data">
         <b-dropdown  dropright variant="outline-secondary" 
         toggle-class="text-decoration-none" no-caret  size="sm"  style="margin:-10px;">
          <template v-slot:button-content>
             <i class="fa fa-play text-success"></i>
          </template>
          <b-dropdown-item @click="rowEdit(data.item)" href="#"  :disabled="data.item.poststatus==1" style="padding:0 !important;">Edit</b-dropdown-item>
          <b-dropdown-item @click="rowPrint(data.item)" href="#" style="padding:0 !important;">Print Form</b-dropdown-item>
          <b-dropdown-item @click="rowDel(data.item)" href="#"  :disabled="data.item.poststatus==1" style="padding:0 !important;"> Delete</b-dropdown-item>
          <b-dropdown-item @click="rowConfirmPosting(data.item)" :disabled="data.item.poststatus==1"> Posting</b-dropdown-item>
          <b-dropdown-item @click="rowConfirmUnPosting(data.item)" :disabled="data.item.poststatus!=1"> Un-Posting</b-dropdown-item>
        </b-dropdown>
      </template>        
      
        <template v-slot:cell(nomor)="data">
          <div  :class="data.item.poststatus==1?'':'bg-warning text-dark'" v-b-tooltip.hover :title="data.item.statustre==1?'':'Data belum diposting'">{{ data.item.nomor}}</div>
        </template>
        <template v-slot:cell(tglpaym)="data">
          {{ data.item.tglpaym | moment("DD/MM/YY") }}
        </template>
        <template v-slot:cell(post_date)="data">
          {{ data.item.post_date | moment("DD/MM/YY") }}
        </template>
        <template v-slot:cell(tgl_terima)="data">
          {{ data.item.tgl_terima | moment("DD/MM/YY") }}
        </template>
        <template v-slot:cell(revstglpaym)="data">
          {{ data.item.revstglpaym | moment("DD/MM/YY") }}
        </template>
        <template v-slot:cell(revspost_date)="data">
          {{ data.item.revspost_date | moment("DD/MM/YY") }}
        </template>
        <template v-slot:cell(isvoid)="data">
          <span v-if="data.item.isvoid==1">Reversed</span><span v-else></span>
        </template>
        
        <template v-slot:cell(totalbank)="data">
          {{data.item.totalbank|numFormat('0,0.00')}}
        </template>
        <template v-slot:cell(totaldiskon)="data">
          {{data.item.totaldiskon|numFormat('0,0.00')}}
        </template>
        <template v-slot:cell(settl_amt)="data">
          {{data.item.settl_amt|numFormat('0,0.00')}}
        </template>
        <template v-slot:cell(pbb_amt)="data">
          {{data.item.pbb_amt|numFormat('0,0.00')}}
        </template>
        
        <template v-slot:empty="scope">
      <h6 class="text-center">{{ scope.emptyText }}</h6>
    </template>
    <template v-slot:emptyfiltered="scope">
      <h6>{{ scope.emptyFilteredText }}</h6>
    </template>
      </b-table>
      <b-row >
        <b-col cols="4">
          <div>
            Showing {{(tblData.page - 1) * tblData.limit + 1}}
            to <span v-if="((tblData.page * tblData.limit)>tblData.total)">{{tblData.total}}</span> <span v-else>{{tblData.page * tblData.limit}}</span>
            of {{tblData.total}} entries
          </div>
        </b-col>
        <b-col cols="4" >
            <b-form-group label-cols=3 label="Limit per page"  style="margin-top:0 !important;">
            <b-form-select :options="[10, 15, 20, 25]" :plain="true" v-model="tblData.limit"  size="sm" style="width:80px;"/>
            </b-form-group>
        </b-col>        
        <b-col cols="4">            
          <b-pagination
            align="right"
            :total-rows="tblData.total"
            :per-page="tblData.limit"
            v-model="tblData.page"
          ></b-pagination>
        </b-col>
      </b-row>
      <b-row >
        <b-col cols="4">
           <b-input-group>
              <b-input-group-prepend>
                <label class="bg-warning mr-2" style="width:50px !important;">&nbsp;</label>
              </b-input-group-prepend>
              <span>Not yet posted</span>
           </b-input-group>
        </b-col>
      </b-row>
    </b-card>
      <b-modal v-model="showDelConfirm" title="Delete Record?" :centered="true" @ok="deleteData">
        <p class="mb-1">1 record is about to be permanently deleted</p>
        <p class="font-weight-bold m-0 text-danger">Warning: You can't undo this action.</p>
      </b-modal>
    <loading :active.sync="isLoading" :height="128" :width="128" color="#4b8cf4" ></loading>       
    <b-modal v-model="showReport" size="xl" title="Preview as PDF" ok-only>
        <iframe :src="reportUrl" frameborder="0"></iframe>
    </b-modal>
        <b-modal v-model="lkuBankaccountShow" size="lg" :hide-footer="true" title="List of Bank/Cash Account" :centered="true">
            <lku-bankaccount @click="onSelectLkuBankaccount"></lku-bankaccount>
        </b-modal>        
      <b-modal v-model="showVoidConfirm" title="Void Transcation?" :centered="true" @ok="voidData">
        <p class="mb-1">1 record is about to be Reversed</p>
        <p class="font-weight-bold m-0 text-danger">Are you sure to doing this ?</p>
      </b-modal>
      <b-modal v-model="showPostingConfirm" title="Posting Transcation?" :centered="true" @ok="postingBulkData" size="md" style="max-width: 560px;">
        <p class="mb-1">Records is about to be Posting</p>
        <b-input-group >
          <b-input-group-prepend><label>Trx. Periode (Post Date)</label></b-input-group-prepend>
        </b-input-group>
        <b-input-group >
          <b-form-input v-model="postingDate.start" type="date" ></b-form-input>
          <b-input-group-prepend><span class="input-group-text">until</span></b-input-group-prepend>
          <b-form-input v-model="postingDate.end" type="date" ></b-form-input>
        </b-input-group>
      </b-modal>
      <b-modal v-model="showUnPostingConfirm" title="Un-Posting Transcation?" :centered="true" @ok="unpostingBulkData" size="md" style="max-width: 560px;">
        <p class="mb-1">Records is about to be Un-Posting</p>
        <b-input-group >
          <b-input-group-prepend><label>Trx. Periode</label></b-input-group-prepend>
        </b-input-group>
        <b-input-group >
          <b-form-input v-model="postingDate.start" type="date" ></b-form-input>
          <b-input-group-prepend><span class="input-group-text">until</span></b-input-group-prepend>
          <b-form-input v-model="postingDate.end" type="date" ></b-form-input>
        </b-input-group>
      </b-modal>
      <b-modal v-model="showRowPostingConfirm" title="Posting Transcation?" :centered="true" @ok="postingData">
        <p class="mb-1">1 record is about to be Posting</p>
        <p class="font-weight-bold m-0 text-danger">Are you sure to doing this ?</p>
      </b-modal>
      <b-modal v-model="showRowUnPostingConfirm" title="Un-Posting Transcation?" :centered="true" @ok="unpostingData">
        <p class="mb-1">1 record is about to be Un-Posting</p>
        <p class="font-weight-bold m-0 text-danger">Are you sure to doing this ?</p>
      </b-modal>
  </div>
</template>

<style lang="scss">
  .list-of-arpaym {
    table {
      td:nth-child(1) {
        width: auto;
      }
      td:nth-child(2) {
        width: auto;
      }
      td {
        .dropdown-item {
            padding: 0.1rem 1.5rem !important;
            font-size: smaller !important;
        }    
      }
    }
 }

 .label-eko{
   max-width:100px;
   min-width: 90px;
   margin-left: 2px;
 }

 .dropdown-menu.show{
       min-height: 104px;
 }
</style>


<script>
import lkuBankaccount from "../lookup/lkuBankaccount";
import crud from "../../apis/crud";
import arpayment from '../../apis/finpaymsuspend';
import dropdown from "../../data/dropdown";

import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';
import moment from "moment";
import toastr from "mini-toastr";
toastr.init();


export default {
  data() {
    return {
      showFilter: true,
      showDelConfirm: false,
      showVoidConfirm:false,
      showPostingConfirm:false,
      showRowPostingConfirm:false,
      showUnPostingConfirm:false,
      showRowUnPostingConfirm:false,
      lkuBankaccountShow: false,
      isLoading:false,
      showReport:false,
      reportUrl: `${location.origin}/#load`,
      model:{},
        items: [],
      tblData: {
        page: 1,
        limit: 15,
        total: 0,
        tgl1:this.$store.state.user.tglaktif,
        tgl2:this.$store.state.user.akhirbln,        
        sortBy: 'tglpaym',
        sortDesc: true,
        DimCol:'Dim1',no_kontrak:'', collector_id:'',optiondate:'post',poststatus:''
      },
      postingDate:{
        start:moment().format('YYYY-MM-DD'),
        end:moment().format('YYYY-MM-DD'), 
        optiondate:'post'
      },
      dataList: {
        arPayment: dropdown.arPayment
      },
      dateOpt:[{value:'post',text:'Post Date'},{value:'value',text:'Value Date'}],      
      postingOpt:[{value:'',text:'-- All --'},{value:1,text:'Yes'},{value:0,text:'No'}],      
      collectors:[{value:'',text:'--- ALL ---'}]
    };
  },
  components: {Loading,lkuBankaccount},
  computed: {
    dimension(){
      return this.$store.state.dimension;
    },
    tblFields(){
      const fields=[
        {
          key: "action",
          label: "",
          thStyle: "width:40px",
          thClass: "text-center",
        },
          {
            key: "nomor",
            thStyle: "width:120px",
            label: "Trx.Bank Number",
            sortable: true
          },
          {
            key: "paymno",
            thStyle: "width:120px",
            label: "Trx.Collection#",
            sortable: true
          },
          {
            key: "tglpaym",
            // thStyle: "width:70px",
            label: "Value Date",
            thClass: "text-center",
            tdClass: "text-right",
            sortable: true
          },
          {
            key: "post_date",
            thStyle: "width:70px",
            label: "Post Date",
            thClass: "text-center",
            tdClass: "text-right",
            sortable: true
          },
          {
            key: "no_kontrak",
            thStyle: "width:100px",
            label: "No. Kontrak",
            sortable: true
          },
          {
            key: "kodebank",
            thStyle: "width:100px",
            label: "Bank Code",
            sortable: true
          },
          {
            key: "namabank",
            // label: "Destination Bank/Acc.",
            label: "Bank Name",
            thStyle: "width:150px",
            sortable: true
          },
          {
            key: "custinfo",
            label: "Receipt From",
            sortable: true
          },
           {
            key: "totalbank",
            label: "Payment Amt.",
            thStyle: "width:120px",
            thClass: "text-right",
            tdClass: "text-right",
            sortable: true
          },
          {
            key: "isvoid",
            label: "Reversed.",
            thStyle: "width:120px",
            thClass: "text-right",
            tdClass: "text-right",
            sortable: true
          },
          {
            key: "createby",
            label: "Issued By",
            thStyle: "width:120px",
            thClass: "text-center",
            tdClass: "text-center",
            sortable: true,
          },
          {
            key: "modified_by",
            label: "Modified By",
            thStyle: "width:120px",
            thClass: "text-center",
            tdClass: "text-center",
            sortable: true,
          },
          // {
          //   key: "revspaymno",
          //   thStyle: "width:120px",
          //   label: "Trx.Collection#",
          //   sortable: true
          // },
          // {
          //   key: "revstglpaym",
          //   // thStyle: "width:70px",
          //   label: "Value Date",
          //   thClass: "text-center",
          //   tdClass: "text-right",
          //   sortable: true
          // },
          // {
          //   key: "revspost_date",
          //   thStyle: "width:70px",
          //   label: "Post Date",
          //   thClass: "text-center",
          //   tdClass: "text-right",
          //   sortable: true
          // },
        ];
        // const dims = this.$store.state.dimension;
        // for (let i = 0; i < dims.length; i += 1) {
        //   fields.push(          {
        //     key: `${dims[i].value}Txt`,
        //     // thStyle: "width:100px",
        //     label: dims[i].text,
        //     sortable: true
        //   },)
        // }
      return fields;
    },
    dimCol() {
        return this.tblData.DimCol;
    }    
  },
  watch:{
    "tblData.tgl1":function(newval) {
      this.postingDate.start=moment(newval).format('YYYY-MM-DD');
    },
    "tblData.tgl2":function(newval) {
      this.postingDate.end=moment(newval).format('YYYY-MM-DD');
    },
    dimCol: function(newval) {
        this.tblData.DimVal="";
        this.tblData.DimValInfo="";
        this.tblData.DimColInfo=this.dimension.find(d => d.value === newval).text;
    },
  },
  created: async function(){
        // const tgl2 = moment(this.$store.state.user.tglaktif, 'YYYY-MM-DD').add(1,'M').subtract(1, 'day');
        // this.tblData.tgl1= this.tblData.tgl1 || this.$store.state.user.tglaktif;
        // this.tblData.tgl2= this.tblData.tgl2 || tgl2.format('YYYY-MM-DD');
        const e = await crud.list({tablename: "vwcollector",page: 1,limit: 1000,sortBy: "collector_name",sortDesc: false});
        // this.collectors=this.collectors.concat(e);
        this.collectors = e.reduce((newArr,item) =>{
            newArr.push({ value: item.collector_id, text: item.collector_name});
            return newArr;
        },[{value:'', text:'--- ALL ---'}]);
  },  
  methods: {
    onSelectLkuBankaccount(_selected) {
        this.tblData.kodebank=_selected.kode;
        this.tblData.namabank=(_selected.namabank2 || _selected.namabank) + ' | '+_selected.nomorrek;
        this.lkuBankaccountShow=false;
    },    
    data: async function(ctx) {
        const filter = this.$store.state.filter;
        let filtered=false;
        for (var key in filter.arpaylist) {
            this.tblData[key] = filter.arpaylist[key];
            filtered=true;
        }
        if (filtered === true) {
          this.tblData.tgl1=filter.arpaylist.tgl1 || '';
          this.tblData.tgl2=filter.arpaylist.tgl2 || '';
          this.showFilter=filtered;
          delete filter.arpaylist;
          this.$store.commit("filter", filter);
        }
      this.tblData.sortDir = this.tblData.sortDesc ? "desc" : "asc";

      const list = await arpayment.list(this.tblData);
      this.items=list;  
      return list;
    },
    togleFilter() {
      this.showFilter=!this.showFilter;
    },
    refresh(ctx) {
      this.$refs.table.refresh();
    },
    search(ctx) {
      this.tblData.page=1;
      this.refresh();
    },
    clearFilter(ctx) {
        this.tblData.kodebank= '';
        this.tblData.namabank= '';
        this.tblData.reference=  '';
        this.tblData.uraian=  '';
        this.tblData.nomor=  '';
        this.tblData.customer=  '';
        this.tblData.tgl1=  '';
        this.tblData.tgl2=  '';
        this.tblData.DimVal=  '';
        this.tblData.tgldue1=  '';
        this.tblData.tgldue2=  '';
        this.tblData.status='';
        this.tblData.no_kontrak=  '';
        this.tblData.collector_id=  '';
        this.tblData.poststatus='';
        this.$forceUpdate();
    },
    saveFilter() {
      const keys = ['uraian', 'DimCol', 'DimVal', 'tgl1', 'tgl2', 'status', 'nomor','nasabahkey', 'customer', 'kodebank','namabank', 'reference', 'no_kontrak', 'tgldue1', 'tgldue2','unearned','collector_id'];
      let filtered = false;
      const arpaylist={};
      for (const key in this.tblData) {
          if (keys.indexOf(key) >= 0 && this.tblData[key]) {
              filtered=true;
              arpaylist[key]=this.tblData[key];
          }
      }
      if (filtered === true) {
          arpaylist.page=this.tblData.page;
          arpaylist.limit=this.tblData.limit;
          arpaylist.sortBy=this.tblData.sortBy;
          arpaylist.sortDesc=this.tblData.sortDesc;
          const filter = this.$store.state.filter;
          filter.arpaylist=arpaylist;
          this.$store.commit("filter", filter);
      }
    },    
    viewwithline(){
      this.saveFilter();
      router.push({name :"loan.paymwithline"});

      // if (this.model.arpaymsusKey) {
      //   this.saveFilter();
      //   router.push({name :'loan.paymsuspendform', params: { arpaymsusKey: this.model.arpaymsusKey}});
      // } else {
      //     toastr.warn('Please select a row that want to be Edit!');
      // }
        
    },       
    rowEdit(record) {
      this.model = record;
      this.edit();
    },
    rowPrint(record) {
      this.rowClicked(record);
        this.printjv();        
    },
    rowDel(record) {
      this.rowClicked(record);
      this.deleteConfirm();
    },
    add(){
      this.saveFilter();
      router.push({name :"loan.paymsuspendform"});
    },
    edit: function() {
        if (this.model.arpaymsusKey) {
          this.saveFilter();
          router.push({name :'loan.paymsuspendform', params: { arpaymsusKey: this.model.arpaymsusKey}});
        } else {
            toastr.warn('Please select a row that want to be Edit!');
        }
    },
    deleteConfirm() {
        if (this.model.arpaymsusKey) {
          this.showDelConfirm = true;
        } else {
            toastr.warn('Please select a row that want to be Delete!');
        }
    },
    deleteData: async function() {
      try {
        this.isLoading=true;
        const paymdt = await arpayment.remove(this.model);
        toastr.success(`Transaction no. : ${paymdt.paymno}has been Deleted!`);
        this.refresh();
        this.isLoading=false;
      } catch (error) {
            if (error.sql) {
                toastr.error(error.sql,'ERROR MESSAGE',10000);
            } else if (error.sqlMessage) {
                toastr.error(error.sqlMessage,'ERROR MESSAGE',10000);
            } else if (error.message) {
                toastr.error(error.message,'ERROR MESSAGE',10000);
            } else {
                toastr.error(JSON.stringify(error),'ERROR MESSAGE',10000);
            }
            this.refresh();
            this.isLoading=false;       
      }
    },
    voidConfirm() {
        if (this.model.arpaymsusKey) {
          this.showVoidConfirm = true;
        } else {
            toastr.warn('Please select a row that want to be Void!');
        }
    },
    voidData: async function() {
        if (this.model.arpaymsusKey) {
            this.saveFilter();
            if(this.model.statustre ==3 ||this.model.isvoid ==1){
              toastr.warn('Transaksi sudah divoid.');
            }else{
              await arpayment.reverse(this.model);
              toastr.success(`Transaction no. : ${this.model.paymno} has been Reverse!`);
              this.refresh();
            }
        } else {
            toastr.warn('Please select a row that want to be Edit!');
        }
    },
    postingConfirm() {
      this.showPostingConfirm = true;
    },
    unpostingConfirm() {
      this.showUnPostingConfirm = true;
    },
    async postingBulkData(){
      try {
        this.isLoading = true;
        await arpayment.postingbulktrx(this.postingDate);
        this.isLoading = false;
        toastr.success(`Posted successfully`,"Posting Transaction");
        this.refresh();
      } catch (error) {
        this.isLoading = false;
              if (error.message) {
                  toastr.error(error.message);
              } else {
                  toastr.error(JSON.stringify(error));
              }
      }
    },
    async unpostingBulkData(){
      try {
        this.isLoading = true;
        await arpayment.unpostingbulktrx(this.postingDate);
        this.isLoading = false;
        toastr.success(`Un-Posted successfully`,"Un-Posting Transaction");
        this.refresh();
      } catch (error) {
        this.isLoading = false;
              if (error.message) {
                  toastr.error(error.message);
              } else {
                  toastr.error(JSON.stringify(error));
              }
      }
    },
    rowConfirmPosting(record){
      if (record.trbankkey) {
          this.showRowPostingConfirm = true;
          this.model ={};
          this.model = record;
        } else {
            toastr.warn('Please select a row that want to be Posting!');
        }
    },
    async postingData(){
      try {
        this.isLoading = true;
        const data = await arpayment.postingtrx(this.model);
        this.isLoading = false;
         toastr.success(
            `Payment No : ${data.paymno} ,Posted successfully`,
            "Posting Transaction"
          );
          this.$refs.table.refresh();
      } catch (error) {
        this.isLoading = false;
              if (error.message) {
                  toastr.error(error.message);
              } else {
                  toastr.error(JSON.stringify(error));
              }
      }
    },
    rowConfirmUnPosting(record){
      if (record.trbankkey) {
          this.showRowUnPostingConfirm = true;
          this.model ={};
          this.model = record;
        } else {
            toastr.warn('Please select a row that want to be Posting!');
        }
    },
    async unpostingData(){
      try {
        this.isLoading = true;
        const data = await arpayment.unpostingtrx(this.model);
        this.isLoading = false;
         toastr.success(
            `Payment No : ${data.paymno} ,Un-Posting successfully`,
            "Un-Posting Transaction"
          );
          this.$refs.table.refresh();
      } catch (error) {
        this.isLoading = false;
              if (error.message) {
                  toastr.error(error.message);
              } else {
                  toastr.error(JSON.stringify(error));
              }
      }
    },

    rowClicked(record, index) {
        if ((this.model) && (this.model._rowVariant)) {
            delete this.model._rowVariant;
        }
        this.model = record;
        record._rowVariant= 'info';
        this.$forceUpdate();
    },
    printjv: async function()
    {
      if (this.model.arpaymsusKey) {
        this.isLoading = true;
          try {
              this.reportUrl= await arpayment.printjv(this.model);
              this.isLoading = false;
              this.showReport=true;
          } catch (error) {
              this.isLoading = false;
              if (error.message) {
                  toastr.error(error.message);
              } else {
                  toastr.error(JSON.stringify(error));
              }
          }
        } else {
            toastr.warn('Please select a row that want to be Printed!');
        }
    },
    exportxls: async function() {
        this.isLoading=true;
        try {
            const response = await arpayment.exportXlsSettlement(this.tblData);
            this.isLoading=false;    
        } catch (error) {
            this.isLoading=false;
            if (error.message) {
                toastr.error(error.message);
            } else {
                toastr.error(JSON.stringify(error));
            }
        }
    },    
    close(){
      router.push("home");
    }
  }
};
</script>
